import Style from "./style";

import useGetAccountParticipationTicketList from "entity/account/useGetAccountParticipationTicketList";
import usePutAccountParticipationTicketCollect from "entity/account/usePutAccountParticipationTicketCollect";

import TStyle from "shared/style/tableStyle";
import timestampCalculator from "shared/lib/timestampCalculator";
import { convertEventStateAsName } from "shared/constant/lookup/eventState";
import { convertEventTypeAsName } from "shared/constant/lookup/eventType";
import useConfirmModalAtom from "shared/model/useConfirmModalAtom";
import DefaultButton from "shared/ui/DefaultButton";
import TableLoading from "shared/ui/TableLoading";

const ParticipationTicket = () => {
  const [ticketList, isLoading] = useGetAccountParticipationTicketList();
  const [collectTicket] = usePutAccountParticipationTicketCollect();
  const [, setConfirm] = useConfirmModalAtom();

  const sizeList = [
    "short",
    "expand",
    "short",
    "longlonglong",
    "long",
    "medium",
    "short",
    "short",
    "long",
    "short",
  ];
  const tableHeadList = [
    "IDX",
    "시리얼 번호",
    "대회 IDX",
    "대회",
    "대회 날짜",
    "대회 종류",
    "대회 상태",
    "사용 여부",
    "획득 날짜",
    "",
  ];

  return (
    <Style.Wrapper>
      <Style.Area>
        <h2>보유</h2>

        <TableLoading isLoading={isLoading}>
          <TStyle.TableDiv>
            <TStyle.TableInner>
              <TStyle.TableRow $title>
                {tableHeadList.map((elem, index) => (
                  <TStyle.Data key={index} $title $size={sizeList[index]}>
                    {elem}
                  </TStyle.Data>
                ))}
              </TStyle.TableRow>
              {ticketList?.data?.participate_ticket_list?.map((elem, index) => (
                <TStyle.TableRow key={index} $odd={index % 2 === 1}>
                  <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                  <TStyle.Data $size={sizeList[1]}>
                    {elem?.serial_number}
                  </TStyle.Data>
                  <TStyle.Data $size={sizeList[2]}>{elem?.event_idx}</TStyle.Data>
                  <TStyle.Data $size={sizeList[3]}>{elem?.event_name}</TStyle.Data>
                  <TStyle.Data $size={sizeList[4]}>
                    {timestampCalculator(elem?.event_date)}
                  </TStyle.Data>
                  <TStyle.Data $size={sizeList[5]}>
                    {convertEventTypeAsName[elem?.event_type_flag]}
                  </TStyle.Data>
                  <TStyle.Data $size={sizeList[6]}>
                    {convertEventStateAsName[elem?.event_state_flag]}
                  </TStyle.Data>
                  <TStyle.Data $size={sizeList[7]}>
                    {elem?.is_used ? "사용됨" : ""}
                  </TStyle.Data>
                  <TStyle.Data $size={sizeList[8]}>
                    {timestampCalculator(elem?.created_at)}
                  </TStyle.Data>
                  <TStyle.Data $size={sizeList[9]}>
                    <DefaultButton
                      small
                      fitWidth
                      deactive={elem?.is_used}
                      clickEvent={() =>
                        setConfirm(
                          "참가권을 회수하시겠습니까?",
                          () => () => collectTicket(elem?.idx)
                        )
                      }
                    >
                      회수
                    </DefaultButton>
                  </TStyle.Data>
                </TStyle.TableRow>
              ))}
            </TStyle.TableInner>
          </TStyle.TableDiv>
        </TableLoading>
      </Style.Area>
    </Style.Wrapper>
  );
};

export default ParticipationTicket;
